interface GameJpegImageSource {
  providerId?: string;
  code?: string;
  imgVer?: string | number;
}

export function getGameJpegImagePath(
  game?: GameJpegImageSource | null
): string {
  return `/assets/game/jpeg/${game?.providerId}/${game?.code}.jpg?ver=${game?.imgVer}`;
}
